"use client";

import React, { createContext, useContext, useMemo, useState } from "react";
import { CheckoutFullPageLoader } from "../ui/checkout-loader";

type Ctx = {
  showCheckoutLoader: (message?: string) => void;
  hideCheckoutLoader: () => void;
};
const LoadingOverlayCtx = createContext<Ctx | null>(null);

export const useLoadingOverlay = () => {
  const ctx = useContext(LoadingOverlayCtx);
  if (!ctx)
    throw new Error(
      "useLoadingOverlay must be used within LoadingOverlayProvider",
    );
  return ctx;
};

export function LoadingOverlayProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState<string | undefined>(undefined);

  const value = useMemo<Ctx>(
    () => ({
      showCheckoutLoader: (msg?: string) => {
        setMessage(msg);
        setVisible(true);
      },
      hideCheckoutLoader: () => {
        setVisible(false);
        setMessage(undefined);
      },
    }),
    [],
  );

  return (
    <LoadingOverlayCtx.Provider value={value}>
      {children}
      {visible && <CheckoutFullPageLoader message={message} />}
    </LoadingOverlayCtx.Provider>
  );
}
